import React, { useCallback } from 'react'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import type { ExploreCategory } from 'tripPlanner/pages/trip/Explore/common'

interface Props {
  category: ExploreCategory
  isSelected: boolean
  onSelect: (category: ExploreCategory) => void
}

function CategoryDropdownItem({
  category,
  isSelected,
  onSelect,
}: Props) {
  const { label, icon: Icon } = category

  const handleClick = useCallback(() => {
    onSelect(category)
  }, [category, onSelect])

  return (
    <ClickableListItem
      title={label}
      size="medium"
      startIcon={<Icon />}
      onClick={handleClick}
      selected={isSelected}
    />
  )
}

export default React.memo(CategoryDropdownItem)
